import React, {useState, useEffect} from "react";
import { HiPlus } from "react-icons/hi";
import { Switch } from "antd";
import {
  DropdownIf,
  DropdownState,
  DropdownValue,
  DropdownDo,
} from "../dropdownIf";

const Index = ({ arg: { index, qtdropdowns,dropdown, setQTDropDowns } }) => {
  console.log(dropdown);
  const [ifDoQuestions, setIfDoQuestions] = useState([]);
  const handleOptionChange = (value, dropDownIndex, optionIndex) => {
    const updatedDropDown = [...qtdropdowns];
    updatedDropDown[dropDownIndex].options[optionIndex].option = value;
    setQTDropDowns(updatedDropDown);
  };

  const handleAddOption = (dropDownIndex) => {
    const updatedDropDown = [...qtdropdowns];
    const lastOptionKey = Math.max(...Object.keys(updatedDropDown[dropDownIndex]['options']).map(key => parseInt(key, 10)));
    const nextKey = lastOptionKey + 1;
    updatedDropDown[dropDownIndex]['options'] = {  ...updatedDropDown[dropDownIndex]['options'],
    [nextKey]: '' };
    setQTDropDowns(updatedDropDown);
  };

  const removeCustomDropdownField = (index) => {
    const updatedDropDown = [...qtdropdowns];
    updatedDropDown.splice(index, 1);
    setQTDropDowns(updatedDropDown);
  };


  const handleSelectChange = (index, conditionIndex, state, value) => {
    console.log(index, state, value);
    const updatedDropDown = [...qtdropdowns];
    if(state === 'do') {
      qtdropdowns.map(dropdown => {
        if(value ===dropdown.question) {
          updatedDropDown[index]['conditions'][conditionIndex]['doType'] = dropdown.type;
          updatedDropDown[index]['conditions'][conditionIndex]['questionId'] = dropdown.uuid;
          
        } else if(value === dropdown.foot_photo) {
          updatedDropDown[index]['conditions'][conditionIndex]['doType'] = dropdown.type;
          updatedDropDown[index]['conditions'][conditionIndex]['questionId'] = dropdown.uuid;

        }
      });
    }
    updatedDropDown[index]['conditions'][conditionIndex][state] = value;
    setQTDropDowns(updatedDropDown);
  };

  const handleSwitchChange = (index, type) => {
    const updatedDropDown = [...qtdropdowns];
    updatedDropDown[index][type] = updatedDropDown[index][type] === "true" ? "false" : "true";
    setQTDropDowns(updatedDropDown);
    
    if(type === 'make_conditional' && updatedDropDown[index][type] === "false") {
      const updatedDropDown = [...qtdropdowns];
      updatedDropDown[index]['if']    = '';
      updatedDropDown[index]['state'] = '';
      updatedDropDown[index]['value'] = '';
      updatedDropDown[index]['do']    = '';

      setQTDropDowns(updatedDropDown);
      getQuestion();
    }
  };

  const inputHandler = (index, type, e) => {
    const { name, value } = e.target;
    const updatedDropDown = [...qtdropdowns];
    updatedDropDown[index][name] = value;
    setQTDropDowns(updatedDropDown);
  };
  const inputOptionHandler = (mainIndex, index, e) => {
    const { name, value } = e.target;
    const updatedDropDown = [...qtdropdowns];
    updatedDropDown[mainIndex]['options'][index] = value;
    setQTDropDowns(updatedDropDown);
  }
  console.log(qtdropdowns);

  const getQuestion = () => {
    qtdropdowns.map(dropdown => {
      if(dropdown.question) {
        // const extractedQuestions = qtdropdowns.filter(dropdown => dropdown.question).map((dropdown, index) => ({ key: dropdown.uuid, value: dropdown.question }));
        const extractedQuestions = qtdropdowns.map(item => { 
          if ((item.type === "dropdown" || item.type === "text")) {
            return { key: item.uuid, value: item.question };
          } else if (item.type === "image") {
            return { key: item.uuid, value: item.foot_photo };
          }
        });
        setIfDoQuestions(extractedQuestions);
      }
    });
  };

    //-----------Generate UUID----------------------
    function generateCustomUUID() {
      let uuid = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      for (let i = 0; i < 24; i++) uuid += characters.charAt(Math.floor(Math.random() * characters.length));
      return uuid;
    }

  const inputHandlerCondition = (index, conditionIndex, type, e) => {
    const { name, value } = e.target;
    const updatedDropDown = [...qtdropdowns];
    updatedDropDown[index]['conditions'][conditionIndex][name] = value;
    setQTDropDowns(updatedDropDown);
  };

  const addNewCondition = (dropDownIndex) => {
    const newUuid = generateCustomUUID();
    const updatedDropDown = [...qtdropdowns];
    const conditions = updatedDropDown[dropDownIndex]['conditions'];
    const lastOptionKey = Math.max(...Object.keys(conditions).map(key => parseInt(key, 10)));
    const nextKey = lastOptionKey + 1;
    updatedDropDown[dropDownIndex]['conditions'] = {  
        ...conditions,
        [nextKey]: {uuid: newUuid, if:'', state: '', value: '', do: '', doType: '' } 
    };
    setQTDropDowns(updatedDropDown);
};

  useEffect(() => { 
    getQuestion();
  }, [qtdropdowns]);

  return (
    <div>
      {/* ------------------Custom Dropdown Field 1----------- */}
      {/* {qtdropdowns.map((qtdropdowns, i) => ( */}
        <div key={index} className="mt-3">
          <hr />
          <div className="tupdate">Custom Dropdown Field {index + 1}</div>
          <div className="row mt-2">
            <div className="col-lg-3 col-md-5 col-sm-12 sub2head">Question</div>
            <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
              <input
                type="text"
                className="form-control"
                name="question"
                value={dropdown.question}
                onChange={(e) => inputHandler(index, 'question', e)}
                placeholder="Was Product 1 installed/serviced?"
                required
              />
            </div>
          </div>

          {/* Render options dynamically */}
          {dropdown.options && typeof dropdown.options === 'object' && Object.keys(dropdown.options).map((option, indexValue) => (
            <div className="row mt-2" key={indexValue}>
              <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                Option {indexValue + 1}
              </div>
              <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                <input
                  type="text"
                  className="form-control"
                  placeholder={`Option ${indexValue + 1}`}
                  name="option"
                  value={dropdown.options[option]}
                  onChange={(e) => inputOptionHandler(index,indexValue, e)}
                  required
                />
              </div>
            </div>
          ))}

          <div className="d-flex justify-content-end mt-3">
            <div
              className="contd"
              style={{ width: "14rem" }}
              onClick={() => handleAddOption(index)}
            >
              Add Dropdown Option
              <span>+</span>
            </div>
          </div>
          <div className="mt-3 d-flex justify-content-between">
            <div className="sub2head mt-2">Require Response</div>
            <Switch onChange={() => handleSwitchChange(index, 'require_response')} defaultChecked={dropdown.require_response === "true" ? true : false} />
          </div>
          <div className="mt-2 d-flex justify-content-between">
            <div className="sub2head mt-2">Make Conditional</div>
            <Switch onChange={() => handleSwitchChange(index, 'make_conditional')} defaultChecked={dropdown.make_conditional === "true" ? true : false} />
          </div>

          {/* ---------dropdown------- */}
          {dropdown.make_conditional === "true" && (
            <div>
              {Object.values(dropdown.conditions).map((condition, conditionIndex) => (
                <>
                  <div className="row mt-2">
                    <div className="col-lg-3 col-md-5 col-sm-12 sub2head">IF</div>
                    <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                      <DropdownIf ifDetail={condition.if} DoValueDetail={condition.do} ifDoQuestions={ifDoQuestions} uuid={condition.uuid} onSelectChange={(value) => handleSelectChange(index, conditionIndex, 'if', value)} />
                    </div>
                  </div>
                  {/* -- */}

                  <div className="row mt-2">
                    <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                      STATE
                    </div>
                    <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                      <DropdownState stateDetail={condition.state}  onSelectChange={(value) => handleSelectChange(index, conditionIndex, 'state', value)} />
                    </div>
                  </div>
                  {/* -- */}
                  <div className="row mt-2">
                    <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                      VALUE
                    </div>
                    <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                      {/* <DropdownValue valueDetail={dropdown.value}  onSelectChange={(value) => handleSelectChange(index, 'value', value)} /> */}
                      <input
                        type="text"
                        className="form-control"
                        name="value"
                        value={condition.value}
                        onChange={(e) => inputHandlerCondition(index, conditionIndex, 'value', e)}
                        placeholder="Enter Value"
                        required
                      />
                    </div>
                  </div>
                  {/* -- */}
                  <div className="row mt-2 pb-2 border-bottom">
                    <div className="col-lg-3 col-md-5 col-sm-12 sub2head">DO</div>
                    <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                      <DropdownDo doDetail={condition.do} ifValueDetail={condition.if} ifDoQuestions={ifDoQuestions} uuid={condition.uuid} onSelectChange={(value) => handleSelectChange(index, conditionIndex, 'do', value)} />
                    </div>
                  </div>
                </>
              ))} 

              <div className="d-flex justify-content-end mt-3">
                <div
                  className="contd"
                  style={{ width: "14rem" }}
                  onClick={() => addNewCondition(index)}
                >
                  Add Condition
                  <span>+</span>
                </div>
              </div>
            </div>
          )}
          <div className="mt-2 d-flex justify-content-end">
            <div className="editbtn mt-2" onClick={() => removeCustomDropdownField(index)}>
              Remove Custom Dropdown Field
            </div>
          </div>
        </div>
      {/* ))} */}
    </div>
  );
};

export default Index;
